import Http from '@/utils/axios'
let therr = new Http({
  version: 'v3.0'
})
let two = new Http({
  version: 'v2.0'
})
// 视频列表
export const getList = (params) => therr.require({ api: 'Course.getList', param: params });
// 视频详情
export const getInfo = (params) => therr.require({ api: 'Course.getInfo', param: params });
// 创建订单
export const createOrder = (params) => therr.require({ api: 'Course.createOrder', param: params });
// 绑定手机号
export const bindMobile = (params) => therr.require({ api: 'Course.bindMobile', param: params });
// 发送验证码
export const setSmsSend = (params) => two.require({ api: 'Base.smsSend', param: params });
// 添加推广关系
export const addExtension = (params) => therr.require({ api: 'Course.addExtension', param: params });
// 查看视频
export const getVideoPlayAuth = (params) => therr.require({ api: 'Course.getVideoPlayAuth', param: params });
// 获取分享
export const getShare = (params) => therr.require({ api: 'Base.getShare', param: params });
// 文章列表【某商家】
export const getArticleList = (params) => therr.require({ api: 'News.getArticleList', param: params });
// 获取订单详情
export const getOrderInfo = (params) => therr.require({ api: 'Base.orderInfo', param: params });
// 获取支付
export const wxPay = (params) => therr.require({ api: 'Base.wxPay', param: params });
// 增加分享数量
export const shareNumUpdate = (params) => therr.require({ api: 'Member.shareNumUpdate', param: params });
//修改成我的课程
export const Course_saveToMe = (params) => therr.require({ api: 'Course.saveToMe', param: params });
//修改成我的课程-列表
export const Course_getMyCourseLists = (params) => therr.require({ api: 'Course.getMyCourseLists', param: params });
//获取课程兑换码详情
export const Exchange_getInfo = (params) => therr.require({ api: 'Exchange.getInfo', param: params });
//领取并使用课程兑换码
export const Exchange_receive = (params) => therr.require({ api: 'Exchange.receive', param: params });
//领取课程兑换码列表
export const Exchange_getExchangeList = (params) => therr.require({ api: 'Exchange.getExchangeList', param: params });